import { IState } from '../../store';

export function canShowOnlineSelector(state: IState): boolean {
  return Boolean(state.offerData.agent && state.offerData.agent.canShowOnline);
}
